// @flow

import React, { type Element, useState } from 'react'
import { TextField } from '@material-ui/core'
import {
  useValidationResult,
  handleChange,
  handleBlur,
  getErrorMsg,
} from '../../../lib/CoreValidations'
import { core } from '../../../lib/WasmCache'

type Props = {
  value: string,
  setValue: (string) => void,
  setIsValid: (boolean) => void,
}

function FacilityNumberField({
  value,
  setValue,
  setIsValid,
}: Props): Element<typeof React.Fragment> {
  const [validationResult, onChange, onBlur] = useValidationResult(core.validateOfficeFacilityCode)
  const [errorObj, setErrorObj] = useState({ isVisible: false, msg: ' ' })

  return (
    <TextField
      id="facility-number"
      label="Facility number"
      variant="outlined"
      value={value}
      onChange={(e) => {
        handleChange(e.target.value.toUpperCase(), onChange, setIsValid, setValue)
        setErrorObj({ isVisible: false, msg: '' })
      }}
      onBlur={(e) => {
        handleBlur(value.toUpperCase(), onBlur, setIsValid)
        setErrorObj({ isVisible: true, msg: getErrorMsg(validationResult) })
      }}
      InputProps={{ inputProps: { style: { textTransform: 'uppercase' } } }}
      fullWidth
      error={!validationResult.is_success && errorObj.isVisible}
      helperText={
        !validationResult.is_success && errorObj.isVisible
          ? errorObj.msg
          : 'This facility number will be associated with your patient panel upload.'
      }
      required
    />
  )
}

export default FacilityNumberField
